import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { modifyPage } from "../ApplicationForm/redux/actions";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useNavigate } from "react-router-dom";

function TabSection(props) {
  const status = useSelector((state) => state.status.statusData);
  const spoc = useSelector((state) => state.spoc.total);
  const [total, setTotal] = useState(0);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const appData = useSelector((state) => state.application.pageInfo);
  const [Link, setLink] = useState("");
  const personalCount = useSelector((state) => state.personal.count);
  const incomeCount = useSelector((state) => state.income.count);
  const incomeTotal = useSelector((state) => state.income.total);
  const eduTotal = useSelector((state) => state.education.total);
  const eduCount = useSelector((state) => state.education);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [phase, setPhase] = useState("Submitted");
  const navigate = useNavigate();

  const [tabs, setTabs] = useState({ personal: 0, income: 0, education: 0 });

  const navigatePage = (page) => {
    const ref = window.location.href;
    let baseUrl = GetBaseUrl(ref);
    let fullurl = ref.replace(/^https?:\/\/(www\.)?/, "").split("/");
    console.log('in navigte', page, fullurl)
    if (fullurl[2] === "app-preview") {
      // window.location.replace(baseUrl + `/application/app-preview/${page}`);
      navigate(`/application/app-preview/${page}`);
    } else if (fullurl[2] === "disburse-form") {
      navigate(`/application/disburse-form/${page}`);
      // window.location.replace(baseUrl + `/application/disburse-form/${page}`);
    } else if(fullurl[2] === "form"){
      // window.location.replace(baseUrl + `/application/form/${page}`);
      navigate(`/application/form/${page}`);
    }
  };
  const getBg = (item) => {
    let bgColor = "#287a5b";
    if (item?.title !== "Application") {
      if (phase === "Submitted") {
        bgColor = "#E9E9E9";
      } else if (
        phase === "Document_Verification" ||
        phase === "RCU_Verification" ||
        phase === "Shortlisted"
      ) {
        if (item?.title === "Result") {
          bgColor = "#E9E9E9";
        } else {
          bgColor = "#222222";
        }
      } else if (
        // phase === "Awarded" ||
        phase === "Wailisted" &&
        item?.title === "Result"
      ) {
        bgColor = "#222222";
      }
    } else {
      bgColor = "#287a5b";
    }
    return bgColor;
  };
  useEffect(() => {
    let newCount = Math.abs((incomeCount / incomeTotal) * 100 - 100);
    setTabs({ ...tabs, income: newCount });
  }, [incomeCount]);

  // useEffect(() => {
  //   // let newCount = Math.abs(((eduCount / eduTotal) * 100) - 100);
  //   // setTabs({ ...tabs, education: newCount });
  // }, [eduCount]);

  useEffect(() => {
    let newCount = personalCount?.field1 + personalCount?.field2;
    newCount = Math.abs((newCount / 10) * 100 - 100);
    setTabs({ ...tabs, personal: newCount });
  }, [personalCount]);

  useEffect(() => {
    let url = window.location.href;
    const cleanedUrl = url.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
    if (cleanedUrl.split("/")[2] === "app-preview") {
      setTotal(100);
    }
    setPhase(tokenData?.applicationStatus);
  }, []);

  return (
    <div className="tabs">
      {props.tabList.map((item, index) => (
        <div
          key={index}
          className={`tab ${phase} ${
            Link.split("/")[2] === item.phase ||
            Link.split("/")[3] === item.phase ||
            (Link.split("/")[2] === "app-preview" &&
              !Link.split("/")[3] &&
              item.title === "Application")
              ? "selected"
              : ""
          } `}
        >
          <div
            className={`tab-title ${item.title}`}
            onClick={() => navigatePage(item.phase)}
          >
            {" "}
            {item.title}
            {/* {Link.split("/")[2] !== "app-preview" && (
              <div className="tab-status">
                {item.phase === "income"
                  ? status.income
                  : item.phase === "personal-details"
                  ? status.personal
                  : status.education}%
              </div>
            )} */}
          </div>
          <div className="status-div">
            <div
              className="status"
              style={{
                width: `${
                  total === 0
                    ? item.phase === "spoc"
                      ? spoc?.spocTotal
                      : item.phase === "bank"
                      ? spoc?.bank
                      : item.phase === "income"
                      ? status.income
                      : item.phase === "personal-details"
                      ? status.personal
                      : status.education
                    : total
                }%`,
                background: getBg(item),

                // `${(tokenData.applicationData.applicationStatus === "Submitted" || tokenData.applicationData.applicationStatus === "Awarded" ||tokenData.applicationData.applicationStatus === "Waitlisted" ) &&
                //   item.title === "Application"
                //     ? "#287a5b" :item.title === "Verification"?
                //     '#222222':'#e9e9e9'
                // }`
              }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TabSection;
